// Feature names shared with the backend (Platform.Distribution FeatureConstants) and
// the seeded dbo.DC_FeatureFlag table. Each screen uses its matching name to resolve
// the current user's permission (Write vs Read) via useFeaturePermission.
export const FEATURE_NAMES = {
  Replenishment: "Replenishment",
  OfficeReplenishmentPO: "OfficeReplenishmentPO",
  ReplenishmentPreferences: "ReplenishmentPreferences",
  ReplenishmentJobConfiguration: "ReplenishmentJobConfiguration",
  VendorOrders: "VendorOrders",
  VendorBackOrders: "VendorBackOrders",
  VendorsToCollectionsMapping: "VendorsToCollectionsMapping",
  AssortmentManagement: "AssortmentManagement",
  OfficePlanograms: "OfficePlanograms",
  ProductPlanogram: "ProductPlanogram",
  ValidateAcuityFrameImport: "ValidateAcuityFrameImport",
  KitMaintenance: "KitMaintenance",
  KitProcessing: "KitProcessing",
  FramePickQueue: "FramePickQueue",
  SpecialOrderQueue: "SpecialOrderQueue",
  FedEx: "FedEx",
  ExpressOffices: "ExpressOffices",
  OpenPull: "OpenPull",
  EcomOrders: "EcomOrders",
  PrintTags: "PrintTags",
  ViewOrders: "ViewOrders",
  VendorAssignment: "VendorAssignment",
  UpdateOrderStatus: "UpdateOrderStatus",
  BulkCostUpdate: "BulkCostUpdate",
  LocationListUpdate: "LocationListUpdate",
  FinalInventoryUpdate: "FinalInventoryUpdate",
  UndoInventoryPost: "UndoInventoryPost",
  Reports: "Reports",
  PlanogramExport: "PlanogramExport",
} as const;

export type FeatureName = (typeof FEATURE_NAMES)[keyof typeof FEATURE_NAMES];
